import { Box } from "@mui/material";

interface DocumentNumberBoxProps {
    value: string | null;
}

export const DocumentNumberBox: React.FC<DocumentNumberBoxProps> = ({ value }) => {
    return (
        <Box
            component="span"
            sx={{
                display: 'inline-block',
                backgroundColor: '#d6d6d6',
                color: '#333',
                px: 0.25,
                py: 0.25,
                borderRadius: '3px',
                fontSize: '0.8rem',
                fontWeight: 600,
                textAlign: 'center',
                lineHeight: 1.4,
            }}
        >
            {value ?? '-'}
        </Box>
    );
};
